module.exports = __webpack_public_path__ + "static/media/volunteer-as-a-group.2621cea4.jpg";